var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-app",
        { staticClass: "d-flex flex-column" },
        [
          _c(
            "v-main",
            { staticClass: "daon-main-wrap" },
            [
              _c("router-view", {
                key: ["ShopDetails", "ShopCoupons", "ShopProducts"].includes(
                  _vm.$route.name
                )
                  ? null
                  : _vm.$route.path,
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }